const doc = [({"en":({"js":({"admin":({"roles":({"ability_groups":({"ability_groups_for":"Ability groups for %{role}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;